/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDayRequest
 */
export interface UpdateDayRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDayRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDayRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDayRequest
     */
    stopIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateDayRequest interface.
 */
export function instanceOfUpdateDayRequest(value: object): value is UpdateDayRequest {
    return true;
}

export function UpdateDayRequestFromJSON(json: any): UpdateDayRequest {
    return UpdateDayRequestFromJSONTyped(json, false);
}

export function UpdateDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'stopIds': json['stopIds'] == null ? undefined : json['stopIds'],
    };
}

  export function UpdateDayRequestToJSON(json: any): UpdateDayRequest {
      return UpdateDayRequestToJSONTyped(json, false);
  }

  export function UpdateDayRequestToJSONTyped(value?: UpdateDayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'stopIds': value['stopIds'],
    };
}

